import { FunctionComponent } from 'react';
import Image from 'next/image';

type PersonalityProps = {
  personality?: [
    {
      name: string;
      url: string;
    }
  ];
};

const Personality: FunctionComponent<PersonalityProps> = ({ personality }) => {
  return (
    <div className="mt-12" id="personality">
      <h2 className="mb-6 text-xl font-bold text-friendly-pink">Personality</h2>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {personality &&
          personality.map((personality, index: number) => (
            <div
              key={`personality-${index}`}
              className="relative flex items-center space-x-3"
            >
              <div className="flex-shrink-0">
                <Image
                  width={58}
                  height={58}
                  className="w-15 h-15"
                  src={personality.url}
                  alt={personality.name}
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm">{personality.name}</p>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default Personality;
